import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import HeaderUnreadButtons from "./HeaderUnreadButtons";
import UnreadModalMobile from "./UnreadModalMobile";
import UnreadModalPC from "./UnreadModalPC";

export default function Unread({
  acceptingProjects,
  acceptingJobs,
  projectIndexUrl,
  jobIndexUrl,
  unreadProjects,
  unreadJobs,
  projectUnreadCount,
  jobUnreadCount,
  totalUnreadCount,
}) {

  const [canProjects, setCanProjects] = useState(acceptingProjects);
  const [canJobs, setCanJobs] = useState(acceptingJobs);

  const [pending, setPending] = useState({ projects: null, jobs: null });

  useEffect(() => {
    const onCommitted = (e) => {
      const d = e.detail || {};
      setCanProjects((prev) => {
        if (typeof d.acceptingProjects === "boolean") return d.acceptingProjects;
        if (pending.projects !== null) return pending.projects;
        return prev;
      });
      setCanJobs((prev) => {
        if (typeof d.acceptingJobs === "boolean") return d.acceptingJobs;
        if (pending.jobs !== null) return pending.jobs;
        return prev;
      });
      setPending({ projects: null, jobs: null });
    };

    const onReverted = () => {
      setPending({ projects: null, jobs: null });
    };

    window.addEventListener("unread:accepting-committed", onCommitted);
    window.addEventListener("unread:accepting-reverted", onReverted);

    return () => {
      window.removeEventListener("unread:accepting-committed", onCommitted);
      window.removeEventListener("unread:accepting-reverted", onReverted);
    }
  }, []);

  const initialType = canProjects ? "projects" : "jobs";
  const [activeType, setActiveType] = useState(initialType);

  useEffect(() => {
    if (activeType === "projects" && !canProjects && canJobs) setActiveType("jobs");
    if (activeType === "jobs" && !canJobs && canProjects) setActiveType("projects");
  }, [canProjects, canJobs, activeType]);

  const [open, setOpen] = useState(false);

  const onOpen = (type) => {
    setActiveType(type || (canProjects ? "projects" : "jobs"));
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onChangeActiveType = (type) => {
    if (type) {
      setActiveType(type);
    }
  };

  const isDesktop = useMediaQuery("(min-width:768px)");

  return (
    <div className="Unread">
      {(canProjects || canJobs) && (
        <HeaderUnreadButtons
          isDesktop={isDesktop}
          acceptingProjects={canProjects}
          acceptingJobs={canJobs}
          onOpen={onOpen}
          projectUnreadCount={projectUnreadCount}
          jobUnreadCount={jobUnreadCount}
          totalUnreadCount={totalUnreadCount}
        />
      )}
      {isDesktop ? (
        <UnreadModalPC
          open={open}
          onClose={onClose}
          activeType={activeType}
          unreadProjects={unreadProjects}
          unreadJobs={unreadJobs}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
        />
      ) : (
        <UnreadModalMobile
          open={open}
          onClose={onClose}
          activeType={activeType}
          acceptingProjects={canProjects}
          acceptingJobs={canJobs}
          onChangeActiveType={onChangeActiveType}
          unreadProjects={unreadProjects}
          unreadJobs={unreadJobs}
          projectIndexUrl={projectIndexUrl}
          jobIndexUrl={jobIndexUrl}
          projectUnreadCount={projectUnreadCount}
          jobUnreadCount={jobUnreadCount}
        />
      )}
    </div>
  );
}

